import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';
import { createNonDisplayOptionDefinition } from './SortOptionsHelper';

export const groupSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'domainName': createNonDisplayOptionDefinition('domainName', OrderKeys.domainName),
  'minSiteRole': createNonDisplayOptionDefinition('minSiteRole', OrderKeys.minimumSiteRole),
  'userCount': createNonDisplayOptionDefinition('userCount', OrderKeys.userCount),
  'grantLicenseMode': createNonDisplayOptionDefinition('grantLicenseMode', OrderKeys.grantLicenseMode),
};
